import { render } from "./ProfileCourseSubpage.vue?vue&type=template&id=19ad058e&scoped=true"
import script from "./ProfileCourseSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileCourseSubpage.vue?vue&type=script&lang=js"

import "./ProfileCourseSubpage.vue?vue&type=style&index=0&id=19ad058e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ad058e"]])

export default __exports__